export default "#map {\n  height: 50vh;\n  width: 90%;\n  margin: auto;\n}"